import { post, put } from './requests'

const resourcePath = 'template_links'

export function updateTemplateLink (id, data) {
  return put(`${resourcePath}/${id}`, data)
}

export function preassignTemplateLinkContacts (id, data) {
  return put(`${resourcePath}/${id}/preassign_contacts`, data)
}

export function useTemplateLink (id, data) {
  return post(`${resourcePath}/${id}/use`, data)
}

export function setDefaultDocumentSender (id) {
  return post(`${resourcePath}/${id}/set_default_document_sender`)
}
